/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Dok_S6Inputs */

const en_tut_dok_s6 = /** @type {(inputs: Tut_Dok_S6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select text and choose **Komentari teks terpilih** to review; an editor closes the thread with **Tandai selesai**.`)
};

const id_tut_dok_s6 = /** @type {(inputs: Tut_Dok_S6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih teks lalu **Komentari teks terpilih** untuk meninjau; penyunting menutupnya dengan **Tandai selesai**.`)
};

/**
* | output |
* | --- |
* | "Select text and choose **Komentari teks terpilih** to review; an editor closes the thread with **Tandai selesai**." |
*
* @param {Tut_Dok_S6Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_dok_s6 = /** @type {((inputs?: Tut_Dok_S6Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Dok_S6Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_dok_s6(inputs)
	return en_tut_dok_s6(inputs)
});